// A connection starts only from the caller's visible click. No boot-time popup.
export function createStandaloneConnection({begin, ready, changed}) {
  let pending=null, connected=false;
  return {
    get connected(){return connected;},
    request(){
      if(connected)return Promise.resolve();
      if(pending)return pending;
      changed('connecting');
      // begin is called synchronously, preserving the browser's user gesture.
      let opening;
      try {opening=begin();} catch(error){changed('failed');return Promise.reject(error);}
      pending=Promise.resolve(opening).then(async session=>{
        await ready(session);connected=true;changed('connected');
      }).catch(error=>{changed('failed');throw error;}).finally(()=>{pending=null;});
      return pending;
    },
  };
}
